/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForWorkloadTtlGeneration extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForWorkloadTtlGeneration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForWorkloadTtlGeneration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForWorkloadTtlGeneration>): BackgroundJobPayloadForWorkloadTtlGeneration {
        let obj = Object.assign(new BackgroundJobPayloadForWorkloadTtlGeneration(), model);
        BackgroundJobPayloadForWorkloadTtlGeneration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForWorkloadTtlGeneration>): BackgroundJobPayloadForWorkloadTtlGeneration {
        if (!model) return null;
        return BackgroundJobPayloadForWorkloadTtlGeneration.newInstance(<BackgroundJobPayloadForWorkloadTtlGeneration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForWorkloadTtlGeneration) {
        if (!obj) return;

        models.BackgroundJobPayloadForWorkloadTtlGeneration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForWorkloadTtlGeneration): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForWorkloadTtlGeneration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Workload ID for ontology generation
     */
    workload_id: string;

    /**
     * Type of event for ontology generation
     */
    event_type: string;

}
